import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const mapAgreementHeaderContainer = (theme: Theme) => css`
  display: flex;
  margin-top: 2rem;
  height: 2.75rem;
  justify-content: space-between;
  align-items: center;
  background-color: ${theme.system.backgroundMuted};
  border: 1px solid ${theme.system.borderBase};
  padding-left: 2rem;
  padding-right: 1rem;
`;

export const containerPdf = (theme: Theme) => css`
  height: 100%;
  margin-bottom: 1rem;
  overflow-y: scroll;
  border: 1px solid ${theme.system.borderBase};
  border-top: 0;
  padding: 1rem;
  background-color: ${theme.system.backgroundMutedActive};
  @media only screen and (min-width: ${dimensions.tablet}) {
    max-height: 21rem;
  }
`;

export const pageWrapper = () => css`
  margin: 1rem 0;
  display: flex;
  justify-content: center;

  div {
    width: 100%;
  }
`;

export const skeleton = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;

export const brandName = css`
  font-weight: ${typography.weightSemiBold};
`;

export const failedToLoad = css`
  height: 100%;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
`;

export const emphasisText = (theme: Theme) => css`
  display: inline;
  color: ${theme.success.textBase};
  font-weight: ${typography.weightSemiBold};
`;
